import * as React from 'react';
import type {EngineConfig} from './EngineConfigProvider';
import {EngineConfigProvider} from './EngineConfigProvider';

export const EngineProvider: React.FC<
  React.PropsWithChildren<Partial<EngineConfig>>
> = ({children, ...config}) => {
  const stableConfig: EngineConfig = React.useMemo(
    () => ({
      cssPolicy: config.cssPolicy ?? 'runtime-only',
      useInsertion: config.useInsertion ?? false,
      ...(config.preserveUndefinedStyleCacheKeys !== undefined && {
        preserveUndefinedStyleCacheKeys: config.preserveUndefinedStyleCacheKeys,
      }),
      ...(config.debug !== undefined && {debug: config.debug}),
    }),
    [
      config.cssPolicy,
      config.useInsertion,
      config.preserveUndefinedStyleCacheKeys,
      config.debug,
    ],
  );

  return (
    <EngineConfigProvider config={stableConfig}>
      {children}
    </EngineConfigProvider>
  );
};
